.wordmark {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mark {
  display: block;
  flex: none;
}

.name {
  font-family: var(--font-display);
  font-weight: 400;
  line-height: 1;
  color: var(--ink);
}
